export default function AttendanceReport() {
    return (
        <div className="page-wrapper">
            <div className="content">
                <h1>Attendance Reports</h1>
            </div>
        </div>
    )
}